import { render, staticRenderFns } from "./PurchaseReceiveList.vue?vue&type=template&id=6d8d1e27&"
import script from "./PurchaseReceiveList.vue?vue&type=script&lang=js&"
export * from "./PurchaseReceiveList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports